import { useQueryData } from "@src/hooks/useQueryData";
import { limitCardsServices, type LeaveLimitCard } from "@src/api/stock/limitCards";

export interface UseWsLimitCardLeavesQueryResult {
    leaves: LeaveLimitCard[];
    isFetching: boolean;
    refetch: () => Promise<unknown>;
}

/**
 * Server-state отпусков лимитной карты на TanStack Query.
 */
export function useWsLimitCardLeavesQuery(limitCardCode: number): UseWsLimitCardLeavesQueryResult {
    const query = useQueryData<LeaveLimitCard[]>({
        queryKey: ["workshop", "wsLimitCard", limitCardCode, "leaves"],
        queryFn: async () => {
            const { items } = await limitCardsServices.leave.load({
                flt: { LimitCardCodes: [limitCardCode] },
                include: ["Bo", "LimitCardContent"],
                includeBo: ["State"],
                includeLimitContent: ["StockObj", "MeasMain"],
            });

            return items;
        },
        enabled: limitCardCode > 0,
        meta: { errorSource: "workshop.wsLimitCard.leaves" },
    });

    return {
        leaves: query.data ?? [],
        isFetching: query.isFetching,
        refetch: query.refetch,
    };
}
